import script from "./QuestHeroPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestHeroPicker.vue?vue&type=script&setup=true&lang=js"

import "./QuestHeroPicker.vue?vue&type=style&index=0&id=1ab558e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab558e2"]])

export default __exports__